import module from './login.module';

module.controller('LoginController', [
  'CurrentUserService',
  'UserAccountService',
  'LoginService',
  '$location',
  function (CurrentUserService, UserAccountService, LoginService, $location) {
    var ctrl = this;
    ctrl.loginButtonText = 'Log in';
    ctrl.loggingIn = false;

    ctrl.loginInfo = {
      username: '',
      password: '',
    };

    ctrl.usernameOrPasswordIncorrect = false;

    ctrl.login = function (loginInfo) {
      ctrl.usernameOrPasswordIncorrect = false;
      ctrl.loginButtonText = 'Logging in...';
      ctrl.loggingIn = true;

      UserAccountService.login(loginInfo.username, loginInfo.password)
        .then(
          function (data) {
            loginInfo.password = '';

            CurrentUserService.checkAuth(true).then(function (data) {
              $('.close').trigger('click');
              var nextState = LoginService.getNextPath();
              const user = data;

              if (nextState) {
                $location.path(nextState);
              }
            });
          },
          function (data) {
            ctrl.usernameOrPasswordIncorrect = true;
          }
        )
        .finally(() => {
          ctrl.loginButtonText = 'Log in';
          ctrl.loggingIn = false;
        });
    };
  },
]);
